import { useEffect, useMemo, useState } from 'react'
import microApp from '@micro-zoe/micro-app'

const _window = window as any

/**
 * 获取用户
 */
export const useUser = () => {
  const [value, setValue] = useState({} as any)

  let globalData = null
  if (_window.__MICRO_APP_BASE_APPLICATION__) {
    // 主应用获取全局数据
    globalData = microApp.getGlobalData() // 返回全局数据
  } else {
    // 子应用获取全局数据
    globalData = _window.microApp.getGlobalData() // 返回全局数据
  }

  const { user = {} } = globalData || {}

  useEffect(() => {
    setValue(user)
  }, [user])

  return value
}
